export function BrandMark() {
  return (
    <span className="brand-mark" aria-label="Sub Zero Treats">
      <span className="brand-mark__crop" aria-hidden="true">
        <img src="/brand/sub-zero-logo-primary.png" alt="" />
      </span>
      <span className="brand-mark__text">Sub Zero Treats</span>
    </span>
  );
}
